var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.PayoutHintPanelFormGroup,{attrs:{"warning":true}},[_c('i18n',{attrs:{"path":"line_1"},scopedSlots:_vm._u([{key:"support",fn:function(){return [_c('a',{attrs:{"href":"/support","title":_vm.$t('службе поддержки')}},[_vm._v(_vm._s(_vm.$t('службе поддержки')))])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }